module.exports = __webpack_public_path__ + "img/tn.95f4516d.svg";